<template>
  <v-flex
    xs12
  >
    <v-expansion-panel>
      <v-expansion-panel-content>
        <template v-slot:header>
          <div>
            <div>
              <h3 class="title font-weight-regular pt-3">
                {{ $t('iCount') }}
              </h3>
            </div>
            <div class="pt-2">
              <div>{{ $t('Configure iCount invoices system.') }}</div>
            </div>
          </div>
        </template>

        <v-divider/>

        <v-layout
          align-center
          justify-center
          row
        >
          <v-flex
            lg6
            md8
            class="pa-4"
          >
            <v-form>
              <v-switch
                v-model="config.general.icount.enabled"
                :label="$t('Enabled')"
                @change="save()"
              />
              <v-switch
                v-model="config.general.icount.send_email"
                :label="$t('Send Email to Customer')"
                @change="save()"
              />
              <v-switch
                v-model="config.general.icount.ignore_pos_guest"
                :label="$t('Ignore PoS Guests')"
                @change="save()"
              />
              <v-text-field
                v-model="config.general.icount.cid"
                :label="$t('CID')"
                @change="save()"
              />
              <v-text-field
                v-model="config.general.icount.user"
                :label="$t('User')"
                @change="save()"
              />
              <v-text-field
                v-model="config.general.icount.pass"
                :label="$t('Password')"
                type="password"
                @change="save()"
              />
              <v-select
                :label="$t('Document Language')"
                v-model="config.general.icount.doc_lang"
                :items="docLang"
                @change="save()"
              />

              <v-divider/>

              <v-switch
                v-model="config.general.icount.send_sms"
                :label="$t('Send SMS to Customer')"
                @change="save()"
              />
              <v-text-field
                v-model="config.general.icount.sms_prefix"
                :disabled="!config.general.icount.send_sms"
                :label="$t('SMS Prefix')"
                @change="save()"
              />
              <v-text-field
                v-model="config.general.icount.sms_suffix"
                :disabled="!config.general.icount.send_sms"
                :label="$t('SMS Suffix')"
                @change="save()"
              />
            </v-form>
          </v-flex>
        </v-layout>

      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-flex>
</template>

<script>
export default {
  name: 'ICountSettings',

  props: {
    config: {
      type: Object,
      required: true
    }
  },

  computed: {
    docLang () {
      return [
        {
          text: this.$t('English'),
          value: 'en'
        },
        {
          text: this.$t('Hebrew'),
          value: 'he'
        }
      ]
    }
  },

  methods: {
    save () {
      if (this.config.length === 0) {
        return
      }

      const settings = this.$http.make('settings', {
        data: this.config.general.icount
      })

      settings.code_url = 'general/icount'
      settings.save().then(() => {
        this.$toast('Settings saved')
      })
    }
  }
}
</script>
